import styled from 'styled-components';

import {
  MyLocation,
  LocalShipping,
  LocationCity,
  FlightTakeoff,
  DirectionsWalk,
} from '@material-ui/icons';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconAirplane = styled(FlightTakeoff)`
  color: ${THEME.blue};
  margin-left: 3px;
`;

export const IconCity = styled(LocationCity)`
  color: ${THEME.orange};
  margin-left: 3px;
`;

export const IconTruck = styled(LocalShipping)`
  color: ${THEME.orange};
  margin-left: 3px;
`;

export const IconWalk = styled(DirectionsWalk)`
  color: ${THEME.green};
  margin-left: 3px;
`;

export const Text = styled.p`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  margin: 0;

  ${props => props.cancelled
    && `
    color: ${THEME.lightGrey};
  `};
`;
